





























































































































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { Association } from '@front-app/services/UserApi/UserModel';
import { Spacing } from '@front-app/components/constants';
import { required } from '@front-app/components/form/validation/validators';
import { v } from '@front-app/components/form/validation/useValidation';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import CountryPicker from '@front-app/components/inputs/CountryPicker.vue';
import RegionPicker from '@front-app/components/inputs/RegionPicker.vue';
import RemoveButton from '@front-app/components/buttons/concrete/XButton.vue';
import OrganizationTypePicker from '@front-app/modules/organization/components/OrganizationTypePicker.vue';

export default defineComponent({
	components: {
		SimpleCard,
		CountryPicker,
		FormSection,
		FormLabel,
		FormError,
		FormInput,
		RegionPicker,
		OrganizationTypePicker,
		RemoveButton,
	},
	props: {
		association: {
			type: Object as PropType<Association>,
			required: true,
		},
	},
	setup(props, ctx) {
		const organizationName = computed(() => props.association.organizationName);
		const orgType = computed(() => props.association.orgType);
		const subGroupName = computed(() => props.association.subGroupName);
		const country = computed(() => props.association.location.country || '');
		const provStateRegion = computed(() => props.association.location.provStateRegion || '');
		const city = computed(() => props.association.location.city || '');

		const validation = v({
			organizationName: {
				value: organizationName,
				rules: [required()],
			},
			orgType: {
				value: orgType,
				rules: [required()],
			},
			subGroupName: {
				value: subGroupName,
				rules: [],
			},
			country: {
				value: country,
				rules: [required()],
			},
			provStateRegion: {
				value: provStateRegion,
				rules: [],
			},
			city: {
				value: city,
				rules: [required()],
			},
		});

		const sendUpdate = (obj: Partial<Association>) => {
			const objectLocation = obj.location || {};
			const val = {
				...props.association,
				...obj,
				location: {
					...props.association.location,
					...objectLocation,
				},
			};
			ctx.emit('input', val);
		};

		const confirmDelete = async () => {
			// eslint-disable-next-line no-alert
			const shouldDelete = window.confirm('Remove this association? (changes will not be saved until you press "submit", below).');
			if (shouldDelete) {
				ctx.emit('delete');
			}
		};

		return {
			confirmDelete,
			sendUpdate,
			organizationName,
			orgType,
			subGroupName,
			country,
			provStateRegion,
			city,
			validation,
			Spacing,
		};
	},
});
